/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


app.controller('CredentialCtrl', ['$rootScope', '$scope', '$http', 'NetworkService', 'MainService', 'Notification', 'LoginService', function ($rootScope, $scope, $http, networkService, MainService, Notification, LoginService) {

        $scope.showCredentials = false;


        
        $rootScope.$on("showCredentials", function (e, credentials) {
            $scope.credentials = credentials;
            $scope.showCredentials = true;
        })
        
         $scope.success = function (msg) {
            Notification.success(msg);
        };
        $scope.error = function (msg) {
            Notification.error(msg);
        };
        
        $scope.closeCredentials = function (e) {
            var t = $(e.target).attr("id")
            if (t == "credentialsPopUp")
            {
                $scope.showCredentials = false;
            }
        }

        $scope.getUrlParameter = function getUrlParameter(sParam) {
            var sPageURL = decodeURIComponent(window.location.search.substring(1)),
                    sURLVariables = sPageURL.split('&'),
                    sParameterName,
                    i;

            for (i = 0; i < sURLVariables.length; i++) {
                sParameterName = sURLVariables[i].split('=');

                if (sParameterName[0] === sParam) {
                    return sParameterName[1] === undefined ? true : sParameterName[1];
                }
            }
        };

        $scope.ignoreCredentials = function ()
        {
            $scope.showCredentials = false;
        }

        $scope.loginWithCredentials = function ()
        {
            networkService.checkLoginToken($scope.credentials.email, $scope.credentials.token, function (data) {
                console.log(data)
                if (data.error)
                {
                    if (data.error == "30")
                    {
                        $scope.error("Du wurdest aus Sicherheitsgründen ausgeloggt, bitte gib deine Login-Daten ein")
                        $scope.showCredentials = false;
                    }
                } else
                {
                    window.location.replace("./start.php");
                }
            })
        }
    }])


